import { createFileRoute } from "@tanstack/react-router";

import { AdminInviteLinks } from "@/features/admin/screens/AdminInviteLinks";

export const Route = createFileRoute(
  "/_authenticated/(admin)/admin/invite-links",
)({
  component: AdminInviteLinks,
});
